import React from "react"
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 9, // Reducir el tamaño de la fuente general
    lineHeight: 1.2,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid black",
    paddingBottom: 4,
  },
  title: {
    fontSize: 11, // Reducir el tamaño del título
    fontWeight: "bold",
    textAlign: "center",
    marginVertical: 8,
  },
  subTitle: {
    fontSize: 9, // Reducir tamaño del subtítulo
    textAlign: "center",
    marginVertical: 4,
  },
  detailItem: {
    marginBottom: 3, // Reducir margen inferior de cada ítem
    fontSize: 8, // Reducir tamaño de la fuente
  },
  details: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 5,
  },
  section: {
    marginBottom: 5, // Reducir el margen entre secciones
  },
  table: {
    display: "table",
    width: "auto",
    marginVertical: 10,
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    padding: 5,
    backgroundColor: "#f2f2f2",
  },
  tableCol: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    borderStyle: "solid",
    padding: 5,
  },
  tableCellHeader: {
    margin: 5,
    fontWeight: "bold",
  },
  tableCell: {
    margin: 5,
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    paddingTop: 10,
  },
  signatureBlock: {
    flex: 1,
    textAlign: "center",
    margin: "0 5px", // Espacio entre las secciones
  },
  signatureLine: {
    borderTop: "1px solid #000",
    width: 200,
    margin: "10px auto",
  },
  footer: {
    textAlign: "center",
    marginTop: 10,
  },
})

const PickingPDF = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <View>
          <Text>{data.usuarioEmision} - crpInvComprobante.Rpt</Text>
        </View>
        <View>
          <Text>Fecha-Impresión: {new Date().toLocaleDateString()}</Text>
          <Text>Hora-Impresión: {new Date().toLocaleTimeString()}</Text>
        </View>
      </View>

      <Text style={styles.title}>MERCATTI S.A.</Text>
      <Text style={styles.subTitle}>COMPROBANTE : {data.codigoComprobante}</Text>

      <View style={styles.section}>
        <View style={styles.details}>
          <View>
            <Text style={styles.detailItem}>Transacción: EGRESO DE BODEGAS INTERNAS</Text>
            <Text style={styles.detailItem}>Fecha Emisión: {normalFormatDate(data.fechaEmision)}</Text>
            <Text style={styles.detailItem}>Hora Emisión: {normalFormatHour(data.horaEmision)}</Text>
            <Text style={styles.detailItem}>Usuario Emisión: {data.usuarioEmision}</Text>
            <Text style={styles.detailItem}>Origen: {"PKE"}</Text>
            <Text style={styles.detailItem}>Descripción: {data.comentario}</Text>
          </View>
          <View>
            <Text style={styles.detailItem}>GENERADO POR: WB</Text>
            <Text style={styles.detailItem}>Bodega: {data.productos[0].bodcodigo}</Text>
            <Text style={styles.detailItem}>Referencia: {data.codigoIngreso + data.codigoEgreso}</Text>
          </View>
        </View>
      </View>

      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={{ width: "15%", ...styles.tableColHeader }}>
            <Text style={styles.tableCellHeader}>Código</Text>
          </View>
          <View style={{ width: "35%", ...styles.tableColHeader }}>
            <Text style={styles.tableCellHeader}>Descripción</Text>
          </View>
          <View style={{ width: "10%", ...styles.tableColHeader }}>
            <Text style={styles.tableCellHeader}>Cantidad</Text>
          </View>
          <View style={{ width: "20%", ...styles.tableColHeader }}>
            <Text style={styles.tableCellHeader}>Lote</Text>
          </View>
        </View>
        {data.productos.map((item, index) => (
          <View style={styles.tableRow} key={index}>
            <View style={{ width: "15%", ...styles.tableCol }}>
              <Text style={styles.tableCell}>{item.artcodigo}</Text>
            </View>
            <View style={{ width: "35%", ...styles.tableCol }}>
              <Text style={styles.tableCell}>{item.artdescri}</Text>
            </View>
            <View style={{ width: "10%", ...styles.tableCol }}>
              <Text style={styles.tableCell}>{item.cantidadSeleccionada}</Text>
            </View>
            <View style={{ width: "10%", ...styles.tableCol }}>
              <Text style={styles.tableCell}>{item.lotes[0]}</Text>
            </View>
          </View>
        ))}
      </View>

      <View style={styles.signatureSection}>
        <View style={styles.signatureBlock}>
          <View style={styles.signatureLine} />
          <Text>ELABORADO POR</Text>
        </View>
        <View style={styles.signatureBlock}>
          <View style={styles.signatureLine} />
          <Text>REVISADO POR</Text>
        </View>
        <View style={styles.signatureBlock}>
          <View style={styles.signatureLine} />
          <Text>RECIBÍ CONFORME</Text>
        </View>
      </View>

      <Text style={styles.footer}>ORIGINAL</Text>
    </Page>
  </Document>
)

export default PickingPDF
